import {clx} from '@hm/fundamental'
import React, {FC, ReactNode} from 'react'

interface PageContainerProps {
  children: ReactNode
  'data-test-id'?: string
  className?: string
}

export const PageContainer: FC<PageContainerProps> = ({
  children,
  'data-test-id': dataTestId,
  className
}) => (
  <div
    className={clx('px-2 py-4 sm:px-4 md:px-6 md:py-6 lg:px-8', className)}
    data-test-id={dataTestId}
  >
    {children}
  </div>
)
